module.exports = __webpack_public_path__ + "static/media/Fogg2.e1eff5d2.png";